import React from "react";
import SMDCard from './SMDCard';
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { getSMDSearchlist } from "../Actions/SMDlistingAPI";

const searchData = { companyname: '', pagenumber: 1, pagesize: 10 };
const ConstSearchItem = { companyname: '', pagenumber: '', pagesize: 10 };
class SMDLibrary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchDate: { companyname: '', pagenumber: 1, pagesize: 10 }, SMDDelete: true
        }
        this.SearchSMDData = this.SearchSMDData.bind(this);
        this.ClearSearchField = this.ClearSearchField.bind(this);
    }
    componentDidMount() {
        this.props.dispatch({ type: 'SubBannerTitle', data: "SDoC LIBRARY" });
        this.props.dispatch(getSMDSearchlist(this.state.searchDate));
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch } = nextProps;
        if (nextProps.SMDisDeleted === true || nextProps.SMDisUpdated === true || nextProps.IsSMDDataAdded === true) {
            dispatch(getSMDSearchlist(prevState.searchDate));
            dispatch({ type: "SMDDelete", data: false })
            dispatch({ type: "SMDUpdate", data: false })
            dispatch({
                type: "SMDPostSuccessfull",
                data: false
            })
        }
    }
    SearchSMDData(pgno) {
        const { dispatch } = this.props;
        this.state.searchDate['pagenumber'] = pgno;
        dispatch(getSMDSearchlist(this.state.searchDate));
        dispatch({ type: "ResetSMD", data: true })
    }
    SearchSMDList(pgno) {
        const { dispatch } = this.props;
        this.state.searchDate['pagenumber'] = pgno;
        dispatch(getSMDSearchlist(this.state.searchDate));
    }
    ClearSearchField() {
        // let param = { ...ConstSearchItem }
        // this.setState({
        //     searchDate: param
        // })
        this.state.searchDate.companyname = "";
        this.props.dispatch(getSMDSearchlist(this.state.searchDate));
        this.setState({});
    }
    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.searchDate[nodeName] = e.target.value;
        this.setState({
        })
    }

    hideSidePanel = () => {
        this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    render() {
        const { arraylist, IsSMDEdit } = this.props;
        return (
            <div className="full-height w-100">
                <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3 mx-4"
                    onClick={() => this.hideSidePanel()}
                >
                    &larr; Back
                        </button>
                {/* <div className="row mr-3 " style={{ height: "50px" }}>
                    {!IsSMDEdit ? <div className="ml-auto m-3 nav-item-link" onClick={this.SMDNewitemNav} style={{ color: "#109AFF" }}>New Item</div> : ''}
                </div> */}
                <div className="grey-bg  course-list-page">
                    <div className="px-4 pt-3">
                        <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                            <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                SDoC Library
                                </h5>
                                <div className="m-1 flex" onClick={this.SMDNewitemNav}>
                                    <span className="mt-1">Add</span><AddIcon />
                                </div>
                            </div>
                        </div>
                        <div className="panel-box search-filter-box mb-3">
                            <div className="row" style={{ paddingBottom: '12px' }}>
                                {/* <div className={IsSMDEdit ? "" : "col-lg-1"}></div> */}
                                <div className="col-lg-6">
                                    <label className="form-label" >Company Name</label><br></br>
                                    <input className="form-control" type="text" name="companyname" onChange={this.handleInputChange.bind(this)} value={this.state.searchDate.companyname}></input>
                                </div>
                                <div className={IsSMDEdit ? "col-lg-6" : "col-lg-6"}>
                                    <label className="form-label" ><p></p></label><br></br>
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.SearchSMDData(1)}> Search </button>

                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.ClearSearchField()}> Clear </button>
                                    </div>
                                </div>
                                <div className={IsSMDEdit ? "" : "col-lg-1"}></div>
                            </div>
                        </div>
                        {arraylist ?
                            <SMDCard arraylist={arraylist} pageSize={this.state.searchDate.pagesize} setUpdatedState={value => this.SearchSMDList(value)} /> : null}

                    </div>
                </div>
            </div>
        )
    }
    SMDNewitemNav = () => {
        this.props.dispatch({ type: 'SMD Library', data: false });
        this.props.dispatch({ type: 'SMDAttchmentUploadSuccess', data: null });
        this.props.history.push("/Home/SMDNewItem")
    }
}
function mapStateToProps(state) {

    return {
        arraylist: state.SidePanReducer.SMDListData,
        SMDisDeleted: state.SidePanReducer.SMDisDeleted,
        IsSMDEdit: state.SidePanReducer.IsSMDEdit,
        Refresh: state.SidePanReducer.Refresh,
        SMDisUpdated: state.SidePanReducer.SMDisUpdated,
        IsSMDDataAdded: state.SidePanReducer.IsSMDDataAdded
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SMDLibrary);
